export { locationPages } from '@/data/myvpnbookDocPages'
